import axios from 'axios';

export const bankApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/banks`,
    headers: {
        'Content-Type': 'application/json'
    }
})